<template>
    <div class="dml-header-search__container" ref="searchDropdown">
        <form action="/wyszukaj"
              autocomplete="off"
              ref="form"
              :class="[`${namespace}__form`, isWhiteTheme && `${namespace}__form--white-theme`]"
              v-on:submit.prevent="handleSubmit"
              data-tracking-submit="search.fired">
            <input data-t="5.9"
                   name="search"
                   v-model="search"
                   v-on:input="handleInput"
                   :class="[`${namespace}__input`, isWhiteTheme && `${namespace}__input--white-theme`, search && 'is-active']"
                   :placeholder="searchText"
                   ref="searchInput">
            <div>
                <button v-if="showSubmitButton" :class="[`${namespace}__btn`, search && 'is-active']" type="submit" data-t="5.3">
                    <slot name="submit" />
                </button>
                <button v-if="(showCloseButton && search.length) || (showCloseButton && namespace === 'page-search')"
                        :class="[`${namespace}__close`, search && 'is-active']"
                        type="button"
                        v-on:click.prevent="close">
                    <slot name="close"></slot>
                </button>
            </div>
        </form>
        <div v-if="showResult" :class="`${namespace}__results-wrapper`">
            <span :class="`${namespace}__results`">
                <div v-if="optionsList.length" :class="`${namespace}__item-wrapper`">
                    <div :class="`${namespace}__item`" v-for="item in optionsList" v-on:click="handleClick(item.value)" :data-t="item.testAttribute">
                        <dm-icon v-show="!isPageSearchNamespace" name="arrow-up-right" class="_smur" :width="20" :height="16" />
                        <span v-html="item.text"></span>
                    </div>
                </div>
            </span>
        </div>
    </div>
</template>
<script>
    import DM from 'DM';
    import debounce from '~/utils/debounce.js';
    import { MostSearched } from '~/utils/most-searched.js';
    import IconComponent from '../shared/icon-component.vue';
    import trackers from '@trackers';

    const SEARCH_TEXT = {
        short: 'Szukaj produktów...',
        long: 'Szukaj wśród milionów produktów i tysięcy okazji'
    }

    export default {
        name: 'dm-search-form',
        data() {
            return {
                search: '',
                list: []
            };
        },
        components: {
            'dm-icon': IconComponent,
        },
        props: {
            namespace: {
                type: String,
                default: 'page-search'
            }
        },
        computed: {
            optionsList() {
                return this.list.map((item, index) => {
                    const props = {
                        text: this.search ? this.getHighlightedText(item.value) : item.value,
                        testAttribute: `5.${index + 10}`
                    };
                    return Object.assign({}, item, props);
                });
            },
            showSubmitButton() {
                return !!this.$slots.submit;
            },
            showCloseButton() {
                return !!this.$slots.close;
            },
            isHeaderSearchNamespace() {
                return this.namespace === 'dml-header-search';
            },
            isPageSearchNamespace() {
                return this.namespace === 'page-search';
            },
            showResult() {
                if (this.isHeaderSearchNamespace && this.search || this.isPageSearchNamespace) {
                    return true;
                }

                return false;
            },
            searchText() {
                return this.isPageSearchNamespace ? SEARCH_TEXT.short : SEARCH_TEXT.long;
            },
            showMostSearched() {
                return !this.isHeaderSearchNamespace;
            },
            isWhiteTheme() {
                return DM.Config.headerColor === '_white';
            }
        },
        methods: {
            handleInput: debounce(function () {
                if (!this.search) {
                    this.list = [];
                } else {
                    DM.Service.Suggest.getOptions(this.search).then(this.requestHandler);
                }
            }, 200),
            requestHandler(data) {
                this.list = data.suggestions;
            },
            handleClick(val) {
                const searchValue = this.search ? this.search : 'fromMostSearchedList';
                const label = `${val}: ${searchValue}`;

                this.search = val;
                this.submitForm(label);
            },
            handleSubmit() {
                this.submitForm();
            },
            submitForm(label = null) {
                trackers.track('search', {
                    value: this.search
                });
                this.$ga.trackEvent({
                    category: 'search',
                    action: label ? 'searchwithsugestion' : 'searchfired',
                    label: label ? label : this.search
                });

                this.$nextTick(() => {
                    this.$refs.form.submit();
                });
            },
            getHighlightedText(text) {
                return text
                    .replace(new RegExp(this.search, 'gi'), '<strong>' + this.search + '</strong>')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/&lt;(\/?strong)&gt;/g, '<$1>');
            },
            close() {
                this.$emit('close');
                this.search = '';
                this.$ga.trackEvent({
                    category: 'search',
                    action: 'close'
                });
            },
            searchDropdownClick(e) {
                if (this.showResult) {
                    const el = this.$refs.searchDropdown;
                    const target = e.target;
                    if ((el !== target) && !el.contains(target)) {
                        this.close();
                    }
                }
            }
        },
        activated() {
            if (this.showMostSearched) {
                this.list = MostSearched;
            }

            this.isPageSearchNamespace && this.$refs.searchInput.focus();
        },
        created() {
            if (this.isHeaderSearchNamespace) {
                document.addEventListener('click', this.searchDropdownClick)
            }
        },
        destroyed() {
            if (this.isHeaderSearchNamespace) {
                document.removeEventListener('click', this.searchDropdownClick)
            }
        }
    };
</script>
